/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 16:15:17
 */
export const queryPage = '/icps/system/sign/basics/werghtEncoder/QueryPage'
export const batchUpdateOrDelete = '/icps/system/sign/basics/werghtEncoder/deletes'
export const updateSortNum = '/icps/system/sign/basics/werghtEncoder/update_sort_num'
export const saveOrUpdate = '/icps/system/sign/basics/werghtEncoder/saveOrUpdate'
export const Download = '/icps/system/sign/basics/werghtEncoder/exportList'
import request from '@/utils/request'
export function qureyCodeIs(data) {
  return request({
    url: '/icps/system/sign/basics/werghtEncoder/QueryCodeByCode',
    method: 'post',
    data
  })
}
export function getStationByCompanyId(data) {
  return request({
    url: '/icps/system/sign/basics/station/getStationByCompanyId',
    method: 'post',
    data
  })
}
/*获取条码类型维护数据*/
export function codingTypegetCodingType(data) {
  return request({
    url: '/icps/system/sign/basics/codingType/getCodingType',
    method: 'POST',
    data
  })
}
/*保存条码类型维护*/
export function codingTypesaveCodingType(data) {
  return request({
    url: '/icps/system/sign/basics/codingType/saveCodingType',
    method: 'POST',
    data
  })
}
